import { motion } from "framer-motion";
import { Disc3, CircleDot, Droplet, Wrench, MessageCircle } from "lucide-react";
import { waLink, SERVICE_MESSAGES } from "@/lib/constants";
import { CarWatermark } from "./Watermark";

const EASE = [0.16, 1, 0.3, 1];

const ITEMS = [
  { icon: Disc3, title: "Pastilhas", desc: "Avaliação do desgaste" },
  { icon: CircleDot, title: "Discos", desc: "Verificação de espessura e condição" },
  { icon: Droplet, title: "Fluido", desc: "Avaliação do sistema" },
  { icon: Wrench, title: "Pinças", desc: "Conferência do funcionamento" },
];

export const BrakesDetail = () => (
  <section id="freios" className="relative py-20 lg:py-28 bg-surface overflow-hidden">
    <CarWatermark className="-right-24 top-10 w-[46rem] rotate-2" tone="red" />
    <div className="relative px-4 sm:px-6 lg:px-10 max-w-[1400px] mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
      >
        <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-6">
          <span className="text-signal">04</span>
          <span className="h-px w-10 bg-signal/60" />
          Revisão de Freios
        </p>
        <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl">
          Freios não são item para <span className="text-signal">deixar para depois.</span>
        </h2>
        <p className="mt-6 text-sm sm:text-base text-gray-400 leading-relaxed max-w-2xl">
          Pastilhas, discos, fluido e pinças trabalham juntos para parar o seu
          carro. Nossa revisão avalia cada item e indica apenas o que realmente
          precisa ser trocado.
        </p>
      </motion.div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {ITEMS.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}
            className="border border-white/[0.08] bg-card p-6 card-glow transition-all duration-500"
          >
            <item.icon className="h-7 w-7 text-signal" />
            <h3 className="mt-4 font-display font-bold uppercase text-xl text-white">{item.title}</h3>
            <p className="mt-1.5 text-sm text-gray-400">{item.desc}</p>
          </motion.div>
        ))}
      </div>

      <motion.a
        data-testid="brakes-whatsapp-button"
        href={waLink(SERVICE_MESSAGES.brakes)}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: EASE }}
        className="btn-cut mt-10 inline-flex items-center gap-2 px-8 py-4 bg-signal hover:bg-signalhover text-white font-display font-bold uppercase tracking-wide text-lg transition-colors duration-300"
      >
        <MessageCircle className="h-5 w-5" />
        Quero Fazer uma Revisão
      </motion.a>
    </div>
  </section>
);
